import React, { useState } from 'react'
import Container from '@material-ui/core/Container'
import { Box, CircularProgress, TextField, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core'
import Button from 'components/Button/Button'
import FeedbackSnackbar from 'shared/components/FeedbackSnackbar/FeedbackSnackbar'
import PageWrapper from 'wrappers/PageWrapper/PageWrapper'
import AdminAPI from 'api/AdminAPI'
import { useStyles } from './AdminSearchComparisonPage_style'
import TallyFeedbackEmbed from './TallyFeedbackEmbed'

const ITEM_TYPE_OPTIONS = [
    { value: 'student_job', label: 'Student Job' },
    { value: 'internship', label: 'Internship' },
    { value: 'first_job', label: 'First Job' },
    // { value: 'companies', label: 'Companies' },
    // { value: 'articles', label: 'Articles' },
]

const AdminSearchComparisonPage = (props) => {
    const { user } = props
    const classes = useStyles()
    const [itemType, setItemType] = useState('')
    const [slug, setSlug] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [results, setResults] = useState({ comparisonItem: {}, oldResults: [], newResults: [] })
    const [feedback, setFeedback] = useState({ open: false, message: null, severity: null })

    const closeFeedback = () => setFeedback({ ...feedback, open: false })

    const handleCompare = () => {
        if (!itemType || !slug) {
            setFeedback({ open: true, message: 'Please select item type and enter a slug.', severity: 'warning' })
            return
        }
        setIsLoading(true)
        AdminAPI.CompareSearch({ item_type: itemType, slug })
            .then((response) => {
                const data = response.data
                if (data.is_success) {
                    setResults({
                        comparisonItem: data.data.item,
                        oldResults: data.data.old_results,
                        newResults: data.data.new_results
                    })
                } else {
                    setFeedback({ open: true, message: data.data.message, severity: 'error' })
                }
            })
            .catch((e) => {
                setFeedback({ open: true, message: 'Error comparing results.', severity: 'error' })
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <PageWrapper user={user} disableFooter disableNavbar>
            <FeedbackSnackbar
                open={feedback.open}
                message={feedback.message}
                severity={feedback.severity}
                closeFeedback={closeFeedback}
            />
            <Container maxWidth="md" className={classes.container}>
                <h1 className={classes.title}>Search Comparison</h1>
                <Box display="flex" alignItems="center" mb={2}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="item-type-label">Item Type</InputLabel>
                        <Select
                            labelId="item-type-label"
                            value={itemType}
                            onChange={(e) => setItemType(e.target.value)}
                            label="Item Type"
                        >
                            {ITEM_TYPE_OPTIONS.map((opt) => (
                                <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        className={classes.slugField}
                        variant="outlined"
                        label="Slug"
                        value={slug}
                        onChange={(e) => setSlug(e.target.value)}
                    />
                    <Button
                        className={classes.compareButton}
                        color="primary"
                        disabled={isLoading}
                        onClick={handleCompare}
                    >
                        {isLoading ? <CircularProgress size={20} /> : 'Compare'}
                    </Button>
                </Box>

                {!isLoading && (results.oldResults.length || results.newResults.length) && (<>
                    <Box display="flex" justifyContent="space-between" mt={4}>
                        <Box>
                            <h2 className={classes.subTitle}>Comparison item</h2>
                            <span>{results.comparisonItem.title}</span>
                        </Box>
                        <Box className={classes.resultBox}>
                            <h2 className={classes.subTitle}>Current Matching</h2>
                            {results.oldResults.length ? (
                                <ul>
                                    {results.oldResults.map((item, idx) => (
                                        <li key={idx}>{item.title || item.slug}</li>
                                    ))}
                                </ul>
                            ) : (
                                <p>No results</p>
                            )}
                        </Box>
                        <Box className={classes.resultBox}>
                            <h2 className={classes.subTitle}>Pinecone Matching</h2>
                            {results.newResults.length ? (
                                <ul>
                                    {results.newResults.map((result, idx) => {
                                        const { score, item } = result
                                        return (
                                            <li key={idx}>
                                                {item.title || item.slug} (Score: {score.toFixed(3)})
                                            </li>
                                        )
                                    })}
                                </ul>
                            ) : (
                                <p>No results</p>
                            )}
                        </Box>
                    </Box>
                    <Box my={1}>
                        <TallyFeedbackEmbed
                            formID={'3xLD1k'}
                            user={user}
                            itemType={itemType}
                            slug={slug}
                        />
                    </Box>
                </>)}
            </Container>
        </PageWrapper>
    )
}

export default AdminSearchComparisonPage
